var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-white"},[_c('p',{staticClass:"text-lg font-semibold"},[_vm._v("Customisable reporting")]),_c('p',{staticClass:"text-sm pt-2 pb-6"},[_vm._v(" A transaction dashboard to provide analytics and insights ")])])
}]

export { render, staticRenderFns }